import React, {useState, useEffect} from "react";
import { Box, Typography, Grid2, Button, CircularProgress } from '@mui/material';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from "../firebase/firebaseConfig";
import SlidesFotosApp from "./SlidesFotosApp";

const MisApp = () => {
    const [caracteristicaProductoWeb, setCaracteristicaProductoWeb] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    // Función para truncar el texto
    const truncateText = (text, maxLength = 200) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    }

    useEffect(() => {
        onSnapshot(collection(db, 'infocaracteristicaproductowebcalocho'),
            (snapshot) => {
                const arregloCaracteristicaProducto = snapshot.docs.map((docCaracteristicaProducto) => {
                    return {...docCaracteristicaProducto.data(), id: docCaracteristicaProducto.id};
                })

                setCaracteristicaProductoWeb(arregloCaracteristicaProducto);
                setLoading(false); // Data has been loaded
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    // Carrusel: Actualizar el índice cada 10 segundos
    useEffect(() => {
        if (currentIndex.length > 1) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % currentIndex.length);
            }, 10000); // 10000ms = 10s
            return () => clearInterval(interval);
        }
    }, [currentIndex.length]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress sx={{ color: '#5d0303' }} />
            </Box>
            );
        }

        if (caracteristicaProductoWeb.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography variant="h6">No hay datos por mostrar</Typography>
            </Box>
        );
    }

    return(
        caracteristicaProductoWeb.length > 0 &&
        <Box xs={10} md={10} lg={9} sx={{ 
            backgroundColor: '#0a1f44', 
            color: '#fff',
            backgroundImage: 'linear-gradient(180deg, #8E0505, #5d0303)',
            display: 'flex', // Mantener el uso de flexbox
            flexDirection: { xs: 'column-reverse', md: 'row' }, // Columnas en pantallas pequeñas, filas en pantallas grandes
            justifyContent: 'center',
            alignItems: 'center', // Centrar el contenido
            width: '100%',
            padding: { xs: '20px', md: '40px' }, // Aumentar el padding en pantallas más grandes
        }}>

            <SlidesFotosApp/>
            <Grid2 key={caracteristicaProductoWeb[currentIndex].id} sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: { xs: '90%', sm: '60%', md: '50%' },
                    height: 'auto',
                    padding: { xs: '5%', sm: '2%' },
                    margin: { xs: '5% auto', sm: '0 auto' },
                    alignItems: 'center',
            }}>
                <Typography variant="h3" sx={{ 
                        fontWeight: 'bold',
                        fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                        margin: { xs: '12px 0', sm: '18px 0' },
                        textAlign: 'center',
                }}>{caracteristicaProductoWeb[currentIndex].titulo}</Typography>
                <Typography variant="h5" sx={{ 
                        fontSize: { xs: '1rem', sm: '1.2rem' },
                        margin: { xs: '10px 0', sm: '15px 0' },
                        textAlign: 'center',
                }}>{caracteristicaProductoWeb[currentIndex].subtitulo}</Typography>
                <Typography variant="body1" sx={{ 
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                        margin: { xs: '8px 0', sm: '12px 0' },
                        textAlign: 'center',
                }}><span>{truncateText(caracteristicaProductoWeb[currentIndex].descripcion)}</span></Typography>
                <Button 
                    variant="outlined" 
                    size="small"
                    sx={{ 
                        width: { xs: '80%', sm: '60%', md: '50%' },
                        alignSelf: 'center',
                        color: '#f9f9f9',
                        background: '#8E0505',
                        borderColor: '#f9f9f9',
                        mt: 2,
                        ':hover': {
                            backgroundColor: '#ff6f61',
                            borderColor: '#f9f9f9',
                        },
                    }}>
                    Ver más
                </Button>
            </Grid2>
        </Box>
    );
}

export default MisApp;